<template>
    <div>
    <v-navigation-drawer
            v-model="drawer"
            app
            class="d-md-none"
            v-if="this.$route.name !== 'dashboard-found' && this.$route.name !== 'found' && this.$route.name !== 'sign-up-promo' && this.$route.name !== 'sign-up-lowdefest'"
    >


        <v-divider></v-divider>

        <div v-if="brand === 'neotag'" class="lang-dropdown ma-3 mb-0 d-flex">
          <v-select
              v-model="$i18n.locale"
              :items="languageArray"
              item-text="name"
              item-value="lang"
              label="Select your language"
              @change="onChangeLocale($event)"
              :menu-props="{ 'maxHeight': '1000px' }"
              id="countrySelect"
          >
            <template v-slot:item="{ item }">
              <span class="select-flag"><gb-flag :code="languageCodeFromLocale(item.lang)" size="mini" /><span class="ml-3">{{ item.name }}</span></span>
            </template>

          </v-select>
        </div>

        <v-list dense nav>
            <v-list-item @click="navigate('home')">
                <v-list-item-action>
                    <v-icon>home</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Home') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('products')" v-if="userIsOrganisation === false">
                <v-list-item-action>
                    <v-icon>storefront</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Shop') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('our-story')">
              <v-list-item-action>
                <v-icon>info</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t('headings.Our story') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('how-it-works')">
                <v-list-item-action>
                    <v-icon>info</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.How it works') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('faqs')">
              <v-list-item-action>
                <v-icon>mdi-frequently-asked-questions</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>FAQs</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('organisations')">
                <v-list-item-action>
                    <v-icon>mdi-handshake-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Partners') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('dashboard')" v-if="userIsOrganisation === true">
                <v-list-item-action>
                    <v-icon>mdi-monitor-dashboard</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Dashboard') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
<!--            <v-list-item @click="navigate('nominate')">-->
<!--                <v-list-item-action>-->
<!--                    <v-icon>stars</v-icon>-->
<!--                </v-list-item-action>-->
<!--                <v-list-item-content>-->
<!--                    <v-list-item-title>{{ $t('menu.Nominate') }}</v-list-item-title>-->
<!--                </v-list-item-content>-->
<!--            </v-list-item>-->
            <v-list-item @click="navigate('activate')">
                <v-list-item-action>
                    <v-icon>mdi-check-decagram</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Activ8</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('account')" v-if="authenticated() === true && userIsOrganisation === false">
                <v-list-item-action>
                    <v-icon>account_circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Account') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
<!--            <v-list-item @click="navigate('account')" v-if="authenticated() === true && userIsOrganisation === false">-->
<!--                <v-list-item-action>-->
<!--                    <v-icon>supervisor_account</v-icon>-->
<!--                </v-list-item-action>-->
<!--                <v-list-item-content>-->
<!--                    <v-list-item-title>My dependants</v-list-item-title>-->
<!--                </v-list-item-content>-->
<!--            </v-list-item>-->
            <v-list-item @click="navigate('sign-up')" v-if="authenticated() === false">
                <v-list-item-action>
                    <v-icon>account_circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Sign up') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('login')" v-if="authenticated() === false">
                <v-list-item-action>
                    <v-icon>mdi-login</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Login') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item @click="navigate('logout')" v-if="authenticated() === true">
                <v-list-item-action>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('menu.Log out') }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>

<!--    <v-app-bar-->
<!--            app-->
<!--            color="#333"-->
<!--            dark-->
<!--    >-->
        <v-app-bar
                absolute
                color="background"
                dense
                scroll-target="#scrolling-content"
                class="app-bar"
                :height="appBarHeight"
        >
<!--            <template v-slot:img="{ props }">-->
<!--                <v-img-->
<!--                        v-bind="props"-->
<!--                        :src="logo"-->
<!--                        contain-->
<!--                        max-width="400"-->
<!--                        max-height="100"-->
<!--                ></v-img>-->
<!--            </template>-->
            <v-app-bar-nav-icon v-if="this.$route.name !== 'dashboard-found' && this.$route.name !== 'found' && this.$route.name !== 'sign-up-promo' && this.$route.name !== 'sign-up-lowdefest'" @click.stop="drawer = !drawer" class="d-md-none"></v-app-bar-nav-icon>
            <v-toolbar-title :class="{'fixed-image': $vuetify.breakpoint.mdAndUp, 'toolbar-title-xs': $vuetify.breakpoint.xsOnly}">
                <router-link
                        :to="{ name: 'home' }"
                        exact
                >
                    <v-img
                            :src="logo"
                            contain
                            :max-width="logoMaxWidth"
                            min-width="100"
                            style="margin-top: 0px"
                            :alt="brand + ' - ' + $t('A revolutionary way to find what\'s yours')"
                    ></v-img>
                </router-link>

            </v-toolbar-title>



<!--            <v-spacer></v-spacer>-->

<!--            <v-img-->
<!--                v-if="this.$route.name === 'sign-up-promo' && this.$route.params.slug === 'rosslyn-park-national-7s-lost-property-system'"-->
<!--                class="mr-3 mr-sm-6"-->
<!--                :src="hsbc"-->
<!--                contain-->
<!--                :max-width="logoWidth"-->
<!--                alt="Rosslyn Park HSBC National Schools Sevens"-->
<!--            ></v-img>-->

<!--            <v-img-->
<!--                v-if="this.$route.name === 'sign-up-promo' && this.$route.params.slug === 'brighton-marathon'"-->
<!--                class="mr-3 mr-sm-6"-->
<!--                :src="bmw"-->
<!--                contain-->
<!--                :max-width="logoWidth"-->
<!--                alt="Brighton Marathon Weekend"-->
<!--            ></v-img>-->


          <v-toolbar-items v-if="this.$route.name === 'dashboard-found' || this.$route.name === 'found'" class="mt-3 mt-md-12">
            <div>
              <h2 class="mb-2 overline primary--text">
                {{ $t('headings.Registered partner?') }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon size="20" color="primary" v-on="on">info</v-icon>
                  </template>
                  <span>{{ $t("If you are a registered partner, please login to get full access, and then rescan the tag") }}.</span>
                </v-tooltip>
              </h2>
              <v-btn class="login-button" small tile elevation="0" color="primary" @click="navigate('logout')">
                {{ $t('buttons.Login to your dashboard') }}
                <v-icon
                    right
                    dark
                >
                  mdi-login
                </v-icon>
              </v-btn>
            </div>

          </v-toolbar-items>

            <v-toolbar-items style="width: 100%" v-if="this.$route.name !== 'dashboard-found' && this.$route.name !== 'found' && this.$route.name !== 'sign-up-promo' && this.$route.name !== 'sign-up-lowdefest'" :class="{'flex-row pl-10': $vuetify.breakpoint.smAndUp, 'flex-row pl-4': $vuetify.breakpoint.xsOnly}">
                <v-row class="d-none d-md-flex align-center ma-0">
                    <router-link
                        :to="{ name: 'home' }"
                        exact
                        class="main-menu"
                    >
                      {{ $t('menu.Home') }}
                    </router-link>
                    <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>

                      <template v-slot:activator="{ on }">
                        <div v-on="on" class="dropdown">
                          {{ $t('menu.About') }}
                        </div>
                      </template>
                      <v-list>
                        <v-list-item-group>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'our-story' }"
                                  exact
                              >
                                {{ $t('headings.Our story') }}
                              </router-link>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'how-it-works' }"
                                  exact
                              >
                                {{ $t('menu.How it works') }}
                              </router-link>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'faqs' }"
                                  exact
                              >
                                {{ $t('menu.Frequently asked questions') }}
                              </router-link>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'environment' }"
                                  exact
                              >
                                {{ $t('menu.Care for the environment') }}
                              </router-link>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                    <router-link
                            :to="{ name: 'products' }"
                            exact
                            class="main-menu"
                            v-if="userIsOrganisation === false"
                    >
                      {{ $t('menu.Shop') }}
                    </router-link>
                    <router-link
                        :to="{ name: 'organisations' }"
                        exact
                        class="main-menu"
                    >
                      {{ $t('menu.Partners') }}
                    </router-link>
                    <router-link
                        :to="{ name: 'contact-us' }"
                        exact
                        class="main-menu"
                    >
                      {{ $t('menu.Contact') }}
                    </router-link>
<!--                  <v-menu offset-y open-on-hover transition="slide-y-transition" bottom>-->

<!--                    <template v-slot:activator="{ on }">-->
<!--&lt;!&ndash;                      <v-btn&ndash;&gt;-->
<!--&lt;!&ndash;                          color="primary"&ndash;&gt;-->
<!--&lt;!&ndash;                          text&ndash;&gt;-->
<!--&lt;!&ndash;                          v-on="on"&ndash;&gt;-->
<!--&lt;!&ndash;                          class="main-menu"&ndash;&gt;-->
<!--&lt;!&ndash;                      >&ndash;&gt;-->
<!--&lt;!&ndash;                        Help&ndash;&gt;-->
<!--&lt;!&ndash;                      </v-btn>&ndash;&gt;-->
<!--                      <div v-on="on" class="dropdown">-->
<!--                        {{ $t('menu.Help') }}-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <v-list>-->
<!--                      <v-list-item-group>-->
<!--                        <v-list-item>-->
<!--                          <v-list-item-title>-->
<!--                            <router-link-->
<!--                                :to="{ name: 'how-it-works' }"-->
<!--                                exact-->
<!--                            >-->
<!--                              {{ $t('menu.How it works') }}-->
<!--                            </router-link>-->
<!--                          </v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-list-item>-->
<!--                          <v-list-item-title>-->
<!--                            <router-link-->
<!--                                :to="{ name: 'faqs' }"-->
<!--                                exact-->
<!--                            >-->
<!--                              {{ $t('menu.Frequently asked questions') }}-->
<!--                            </router-link>-->
<!--                          </v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                        <v-list-item>-->
<!--                          <v-list-item-title>-->
<!--                            <router-link-->
<!--                                :to="{ name: 'contact-us' }"-->
<!--                                exact-->
<!--                            >-->
<!--                              {{ $t('menu.Contact us') }}-->
<!--                            </router-link>-->
<!--                          </v-list-item-title>-->
<!--                        </v-list-item>-->
<!--                      </v-list-item-group>-->
<!--                    </v-list>-->
<!--                  </v-menu>-->
<!--                    <router-link-->
<!--                            :to="{ name: 'environment' }"-->
<!--                            exact-->
<!--                            class="main-menu"-->
<!--                    >-->
<!--                        {{ $t('menu.Environment') }}-->
<!--                    </router-link>-->
<!--                    <router-link-->
<!--                            :to="{ name: 'sign-up' }"-->
<!--                            exact-->
<!--                            class="main-menu"-->
<!--                            v-if="authenticated() === false"-->
<!--                    >-->
<!--                        {{ $t('menu.Sign up') }}-->
<!--                    </router-link>-->
<!--                    <router-link-->
<!--                            :to="{ name: 'nominate' }"-->
<!--                            exact-->
<!--                            class="main-menu"-->
<!--                    >-->
<!--                        {{ $t('menu.Nominate') }}-->
<!--                    </router-link>-->
<!--                    <router-link-->
<!--                            :to="{ name: 'dashboard' }"-->
<!--                            exact-->
<!--                            class="main-menu"-->
<!--                            v-if="userIsOrganisation === true"-->
<!--                    >-->
<!--                        My organisation-->
<!--                    </router-link>-->
                    <router-link
                            :to="{ name: 'activate' }"
                            exact
                            class="main-menu"
                            v-if="userIsOrganisation === false"
                    >
                        <v-img
                            class="white--text align-end"
                            width="80px"
                            :src="activ8Logo"
                            eager
                        >
                        </v-img>
                    </router-link>
                </v-row>

              <v-spacer></v-spacer>

              <div v-if="brand === 'neotag'" style="margin-top: 51px" class="lang-dropdown ml-12 d-none d-md-flex">
                <v-select
                    v-model="$i18n.locale"
                    :items="languageArray"
                    item-text="name"
                    item-value="lang"
                    label="Select your language"
                    @change="onChangeLocale($event)"
                    :menu-props="{ 'maxHeight': '1000px' }"
                    id="countrySelect"
                >
                  <template v-slot:item="{ item }">
                    <span class="select-flag"><gb-flag :code="languageCodeFromLocale(item.lang)" size="mini" /><span class="ml-3">{{ item.name }}</span></span>
                  </template>

                </v-select>
              </div>


                  <div class="d-flex align-start flex-column">

                    <div :class="{
                      'account-block logged-in-block d-flex align-center': $vuetify.breakpoint.mdAndUp && authenticated(),
                      'account-block logged-in-block small d-flex align-center justify-space-between': $vuetify.breakpoint.smAndDown && authenticated(),
                      'account-block logged-in-block-xs': $vuetify.breakpoint.xsOnly && authenticated(),
                      'account-block logged-out-block d-flex align-center': $vuetify.breakpoint.mdAndUp && authenticated() === false,
                      'account-block logged-out-block small d-flex align-center justify-space-between': $vuetify.breakpoint.smAndDown && authenticated() === false,
                      'account-block logged-out-block-xs': $vuetify.breakpoint.xsOnly && authenticated() === false
                    }">
                      <div class="d-flex flex-column">
                        <router-link
                            :to="{ name: 'login' }"
                            exact
                            v-if="authenticated() === false"
                            class="d-block"
                        >
                          {{ $t('menu.Login') }}
                        </router-link>
                        <router-link
                            :to="{ name: 'sign-up' }"
                            exact
                            v-if="authenticated() === false"
                            class="d-block"
                        >
                          {{ $t('menu.Register') }}
                        </router-link>
                      </div>


                      <v-menu bottom offset-y open-on-hover v-if="authenticated()">
                        <template v-slot:activator="{ on }">
                          <v-btn
                              icon
                              v-on="on"
                          >
                            <v-btn icon text>
                              <v-icon dense color="white">person</v-icon>
                            </v-btn>
                          </v-btn>
                        </template>

                        <v-list>
                          <v-list-item
                              v-if="userIsOrganisation === true"
                          >
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'dashboard' }"
                                  exact
                              >
                                {{ $t('menu.Dashboard') }}
                              </router-link>
                            </v-list-item-title>

                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  v-if="userIsOrganisation === true"
                                  :to="{ name: 'account' }"
                                  exact
                              >
                                {{ $t('menu.Account') }}
                              </router-link>
                              <router-link
                                  v-else
                                  :to="{ name: 'account' }"
                                  exact
                              >
                                {{ $t('menu.Dashboard') }}
                              </router-link>
                            </v-list-item-title>

                          </v-list-item>
                          <v-list-item>
                            <v-list-item-title>
                              <router-link
                                  :to="{ name: 'logout' }"
                                  exact
                              >
                                {{ $t('menu.Logout') }}
                              </router-link>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <v-divider
                          :class="{'mx-4 divider': $vuetify.breakpoint.smAndUp, 'mx-2 divider': $vuetify.breakpoint.xsOnly}"
                          inset
                          vertical
                          v-if="userIsOrganisation === false && authenticated()"
                      ></v-divider>

                      <div v-if="userIsOrganisation === false && authenticated()">
                        <v-menu
                            v-model="basket.popover"
                            :open-on-hover="false"
                            :close-on-content-click="false"
                            :nudge-width="200"
                            offset-y

                        >
                          <template v-slot:activator="{ on }">
                            <v-badge
                                color="black"
                                left
                                class="basket-badge"
                                :content="basketTotal"
                                offset-x="10"
                                offset-y="20"
                            >
                              <v-btn
                                  text
                                  :small="basketButtonSize"
                                  v-on="on"
                                  @click="navigate('basket')"
                              >
                                <v-icon

                                    color="white"
                                >shopping_cart</v-icon>
                              </v-btn>

                            </v-badge>

                          </template>

                          <v-card>

                            <Basket />

                            <div class="pa-4">
                              <v-btn
                                  tile
                                  block
                                  elevation="0"
                                  @click="closeBasket"
                              >
                                {{ $t('buttons.Close') }}
                              </v-btn>
                            </div>


                          </v-card>


                        </v-menu>
                      </div>

                    </div>
                    <div :class="{'logged-in-as-block': $vuetify.breakpoint.mdAndUp, 'logged-in-as-block small': $vuetify.breakpoint.smAndDown}" v-if="authenticated()">
                      <p class="mb-0">{{ $t('Welcome') }} {{usersName}}</p>
                      <p class="mb-0 d-none d-md-block" v-if="adminForOrganisations && adminForOrganisations.length > 0">{{ $t('Admin for') }} {{adminForOrganisations[0].name}}</p>
                    </div>
                  </div>




            </v-toolbar-items>


        </v-app-bar>

    </div>
</template>

<script>

    import { store } from '../store';
    import Basket from './Basket';
    import { mapState } from 'vuex'
    import {i18n} from "../i18n";

    let logo = require('@/assets/logo-short.png')
    let logoNeotag = require('@/assets/neotag-logo.png')
    let hsbc = require('@/assets/hsbc2.png')
    let bmw = require('@/assets/run-co-bmw.png')
    let shoe = require('@/assets/IMG_2834.jpg')
    import { mapActions } from 'vuex';



    export default {
        name: "Menu",
        components: {
            Basket
        },
        props: ['offset'],
        data: () => ({
            //admin: false,
            hsbc: hsbc,
            bmw: bmw,
            shoe: shoe,
            drawer: false,
            on: true,
            extended: false,
            extendedSlot: true,
            prominent: false,
            dense: false,
            collapse: false,
            flat: false,
            bg: false,
            extensionHeight: 48
        }),
        methods: {
            ...mapActions('account', ['switchRole']),
            ...mapActions('basket', ['closeBasket']),
            onChangeLocale(event) {
              i18n.locale = event

              // if (event === 'es') {
              //   this.$vuetify.theme.dark = true
              // }
              // else {
              //   this.$vuetify.theme.dark = false
              // }

              store.dispatch('setLocale', event, {root: true}).then(() => {
                //
              })
            },
            languageCodeFromLocale(locale) {
              if (locale === 'en') {
                return 'gb'
              }
              else {
                return locale
              }
            },
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            adminFor () {
                let user = this.user;
                if (user && user.roles && store.getters['account/isAdmin']) {
                    return 'For ' + user.admin_for_organisations[0].name
                }
            },
            authenticated () {
                return store.state.authenticated
            },
            switchAdmin () {
                return this.switchRole().then(() => {
                    console.log('switch')
                })
            }
        },
        computed: {
            ...mapState({
                user: state => state.account.user,
                adminForOrganisations: state => state.account.user.admin_for_organisations,
                basket: state => state.basket,
                usersName: state => state.account.user.name,
                organisationSlug: state => state.referringOrganisation,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            languageArray() {
              console.log(i18n.locale)
              return [
                {
                  name: i18n.t('messages.English'),
                  lang: 'en'
                },
                {
                  name: i18n.t('messages.Spanish'),
                  lang: 'es'
                }
              ]
            },
            activ8Logo() {
                if (this.brand === 'neotag') {
                  return require('@/assets/activ8-logo-alpha-dark.png')
                }
                return require('@/assets/activ8-logo.png')
            },
            logoMaxWidth() {
              if (this.brand === 'neotag') {
                if (screen.width <= 600) {
                  return 150
                }
                else {
                  return 250
                }
              }
              return 250
            },
            admin: {
                get: () => store.getters['account/isAdmin'],
                set: () => console.log('dummy setter')
            },
            logo() {
                if (this.brand === 'neotag') {
                  return logoNeotag
                }
                return logo
            },
            logoWidth() {
              if (this.$vuetify.breakpoint.name === 'xs') {
                return 140
              }
              if (this.$vuetify.breakpoint.name === 'sm') {
                return 200
              }
              return 220

            },
            basketButtonSize () {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    return true
                }

                return false
            },
            appBarHeight () {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    return 80
                }

                return 120
            },
            basketTotal () {
                return store.getters['basket/productsCount']
            },
            userIsOrganisation() {
                return store.getters.userHasRole(['organisation'])
            },
            adminForOrganisation() {
                let user = this.user;
                if (user && user.admin_for_organisations) {
                    return user.admin_for_organisations[0].name
                }
                return null
            },
            userRoles () {
                let user = this.user;
                if (user && user.roles) {
                    return user.roles
                }
                return [];
            }
        }
    }
</script>

<style scoped>
    .v-application header a, .v-application header .dropdown {
      padding: 5px 15px !important;
    }
    .brand-pink {
        color: #cd0059
    }
    .fixed-image .v-image__image--contain {
        position: fixed !important;
        background-position: left !important;
        max-width: 350px;
    }
    .v-application .account-block .router-link-active {
      color: var(--v-textOnPrimary-base);
    }
    .logged-out-block {
      background-color: var(--v-primary-base);
      /*height: 50px;*/
      padding: 5px;
      margin-left: 20px;
      margin-right: -16px;
      min-width: 275px;
    }
    .logged-out-block.small {
      margin-left: 0;
      min-width: 150px;
    }
    .logged-out-block.logged-out-block-xs.small {
      /*height: 40px;*/
      min-width: 110px;
    }
    .logged-out-block.logged-out-block-xs.small a {
      font-size: 12px;
      padding: 5px !important;
    }
    .logged-out-block.logged-out-block-xs.small .basket-badge {
      font-size: 14px;
      min-width: 100px;
    }
    .v-application header .logged-out-block a:hover {
      color: black;
    }
    .logged-in-block {
        background-color: var(--v-primary-base);
        height: 50px;
        padding: 5px;
        margin-left: 20px;
        margin-right: -16px;
        min-width: 275px;
    }
    .logged-in-block.small {
        margin-left: 0;
        min-width: 210px;
    }
    .logged-in-block.logged-in-block-xs.small {
        height: 40px;
        min-width: 210px;
    }
    .logged-in-block.logged-in-block-xs.small a {
        font-size: 16px;
        padding: 5px;
    }
    .logged-in-block.logged-in-block-xs.small .basket-badge {
        font-size: 14px;
        min-width: 50px;
    }
    .logged-in-as-block {
        height: 50px;
        padding: 5px;
        margin-left: 20px;
        margin-right: -16px;
        min-width: 275px;
        line-height: 1.4em;
    }
    .logged-in-as-block.small {
        margin-left: 0;
        min-width: 210px;
        line-height: 1.1em;
    }
    .basket-badge {
        margin-left: 10px;
        font-size: 18px;
        font-weight: bold;
        min-width: 80px;
    }
    .divider {
        border-color: #fff;
    }
    .app-bar {
        z-index: 2;
    }
    .app-bar-small {
        height: 70px;
    }
    .v-toolbar.v-toolbar--absolute {
        z-index: 3 !important;
    }
    button, .v-tab {
        text-transform: none;
        font-family: 'Lato', sans-serif;
        font-weight: bold;
    }
    .v-application .router-link-active {
        color: var(--v-primary-base);
    }
    .v-application header a, .v-application header .dropdown {
        color: var(--v-menuText-base);
        padding: 15px 15px;
        font-weight: bold;
        font-size: 18px;
        font-family: 'Lato', sans-serif;
    }
    .v-application a:hover, .v-application header .dropdown:hover {
        text-decoration: none;
        color: var(--v-primary-base);
    }
    .v-application a.main-menu:hover, .v-application .dropdown:hover {
        background-color: var(--v-menuBackground-base);
    }
    .v-application header .logged-in-block a {
        color: #fff;
    }
    .v-application header .logged-in-block a:hover {
        color: #000;
    }
    .v-toolbar__items > .v-btn {
        height: auto !important;
    }
    .v-toolbar__title.toolbar-title-xs {
        padding-left: 0 !important;
    }
    .login-button.v-btn {
      /*border-radius: 15px;*/
      /*height: 56px !important;*/
      /*padding-left: 20px !important;*/
      /*padding-right: 20px !important;*/
      /*text-transform: none !important;*/
    }

</style>

<style>
  .select-flag img:not(.md-image) {
    height: 30px !important;
  }

  .chosen-flag {
    width: 50px;
    max-height: 60px;
  }
</style>
